<template>
  <section
    :class="{ 'select-list --horizontal': isHorizontal }"
    class="select-list"
  >
    <label v-if="label">{{ label }}</label>
    <div class="holder">
      <div v-if="isReady">
        <p v-if="placeholder">
          {{ placeholder }}
        </p>
        <selecter
          :svg="svg"
          :list-from-store="list"
          :placeholder="placeholder || simplePlaceholder"
          :name="name"
          :selected="selected"
          :error="error"
          @item="updatedSelecter"
        />
      </div>
      <slot />
    </div>
  </section>
</template>

<script>
import Selecter from '../Selecter'

export default {
  props: {
    active: {
      type: Boolean,
      default: true,

    },
    alert: {
      type: Boolean,
      default: false,

    },
    svg: {
      type: String,
      default: '',
    },
    listFromStore: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    simplePlaceholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    selected: {
      type: [Number, String],

      default: null,
    },
    error: {
      type: Object,
      default: () => {},
    },
    isHorizontal: {
      type: [Boolean, Object],

      default: false,
    },
  },
  components: {
    Selecter,
  },
  data() {
    return {
      list: [],
      isReady: false,
    }
  },
  mounted() {
    this.setList()
  },
  methods: {
    setList() {
      if (this.name === 'country') {
        return this.setCountryList()
      }
      this.listFromStore.forEach((element, index) => {
        this.list.push(element)
        if (index + 1 === this.listFromStore.length) {
          this.isReady = true;
        }
      })
    },
    setCountryList() {
      window.renaultRent.countries.forEach((element, index) => {
        this.list.push(element)
        if (index + 1 === window.renaultRent.countries.length) {
          this.isReady = true;
        }
      })
    },
    updatedSelecter(val) {
      return this.name
        ? this.$emit('updatedSelecter', val)
        : this.$emit('updatedSelecter', val)
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../../../../_src/sass/config/vars';
@import '../../../../../../_src/sass/config/mixins';
@import '../../../../../../_src/sass/config/responsive';

.select-list {
  margin-bottom: 15px;

  &.--horizontal {
    display: flex;
    flex-direction: row;

    label {
      display: flex;
      flex: 1;
    }

    div {
      align-content: center;
      display: flex;
      flex: 1;
      justify-content: center;

      .selecter,
      p {
        flex: 1;
      }

      p {
        margin-bottom: 0;
      }
    }
  }

  .holder {
    flex-direction: column;
  }
}

label {
  @include labels;

  display: block;
  margin-bottom: 10px;
}

.error span {
  @include errorInputs;
}
</style>
